import { UserAuthOptions } from "./user-auth-form.types";

export const getOptionValue = (option: UserAuthOptions) => {
  if (option === UserAuthOptions.on) return true;
  if (option === UserAuthOptions.off) return false;
  if (option === UserAuthOptions.default) return undefined;
};

export const getDefaultOption = (value: boolean | undefined) => {
  if (typeof value === "undefined") {
    return UserAuthOptions.default;
  }
  return value ? UserAuthOptions.on : UserAuthOptions.off;
};
